import { z } from 'zod';
import { Email, Id, IsoDate, Password, Slug, Url } from './common';
import { OfferLinkStatus } from './enums';
/* ============================================================================
   Offer links (PLAN §4.3): created in Mission HQ, shared manually (WhatsApp/QR),
   claimed on the public landing page → onboarding.
   ========================================================================== */
export const OfferPrefillSchema = z.object({
    companyName: z.string().max(80).optional(),
    ownerEmail: z.string().email().optional(),
    companyLogoUrl: Url.optional(),
    welcomeLine: z.string().max(200).optional(),
});
export const OfferFunnelSchema = z.object({
    opened: z.number().int().nonnegative(),
    started: z.number().int().nonnegative(),
    claimed: z.number().int().nonnegative(),
});
export const OfferLinkSchema = z.object({
    id: Id,
    offerId: Id,
    name: z.string(),
    slug: z.string(),
    url: Url,
    plan: z.object({ id: Id, name: z.string() }),
    durationMonths: z.number().int().positive(),
    claimBy: IsoDate,
    singleUse: z.boolean(),
    maxClaims: z.number().int().positive().nullable(),
    claimCount: z.number().int().nonnegative(),
    status: z.enum(OfferLinkStatus),
    prefill: OfferPrefillSchema,
    note: z.string().nullable(),
    funnel: OfferFunnelSchema,
    createdBy: z.string(),
    createdAt: IsoDate,
});
export const OfferLinkCreateSchema = z.object({
    name: z.string().trim().min(3).max(80),
    planId: Id,
    durationMonths: z.number().int().min(1).max(120),
    claimBy: IsoDate,
    singleUse: z.boolean(),
    maxClaims: z.number().int().min(1).max(10000).optional(),
    prefill: OfferPrefillSchema.optional(),
    note: z.string().max(500).optional(),
});
export const OfferLinkUpdateSchema = z.object({
    name: z.string().trim().min(3).max(80).optional(),
    claimBy: IsoDate.optional(),
    note: z.string().max(500).optional(),
});
/** QR + share data for a link (mobile share sheet, WhatsApp deep link). */
export const OfferShareSchema = z.object({
    url: Url,
    whatsappUrl: Url,
    shareText: z.string(),
    /** QR matrix (true = dark module), rendered by the client to canvas/PNG */
    qr: z.array(z.array(z.boolean())),
});
/** Public offer landing page (claim.html). */
export const PublicOfferSchema = z.object({
    slug: z.string(),
    state: z.enum(['valid', 'claimed', 'expired', 'revoked']),
    companyName: z.string().nullable(),
    companyLogoUrl: z.string().url().nullable(),
    welcomeLine: z.string().nullable(),
    planName: z.string(),
    durationMonths: z.number().int().positive(),
    claimBy: IsoDate,
    highlights: z.array(z.string()),
    contact: z.object({ whatsapp: z.string().nullable(), email: z.string() }),
});
/** Claim → creates the tenant + owner and returns a session (onboarding step 1). */
export const OfferClaimSchema = z.object({
    companyName: z.string().trim().min(2).max(80),
    slug: Slug,
    ownerName: z.string().trim().min(2).max(80),
    ownerEmail: Email,
    password: Password,
    acceptTerms: z.literal(true),
});
export const SlugAvailabilitySchema = z.object({
    slug: z.string(),
    available: z.boolean(),
    reason: z.enum(['taken', 'reserved', 'invalid']).nullable(),
    suggestion: z.string().nullable(),
});
//# sourceMappingURL=offers.js.map